module.exports = __webpack_public_path__ + "static/media/mbari_blur.8b03ab5f.jpg";